// src/components/Footer.jsx
import React from 'react';
import { Activity, History } from 'lucide-react'; // ← 回転率 + 履歴アイコン
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="fixed bottom-0 w-full bg-blue-800 text-white border-t z-50">
      <div className="flex justify-around items-center h-14">
        {/* 回転率リンク */}
        <div className="flex flex-col items-center">
          <Link
            to="/detail"
            aria-label="回転率（詳細入力）へ移動"
            className="inline-flex flex-col items-center"
          >
            <Activity className="w-6 h-6" />
            <span className="text-xs">回転率</span>
          </Link>
        </div>

        {/* 履歴リンク */}
        <div className="flex flex-col items-center">
          <Link
            to="/history"
            aria-label="履歴ページへ移動"
            className="inline-flex flex-col items-center"
          >
            <History className="w-6 h-6" />
            <span className="text-xs">履歴</span>
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
